/** @format */

import angular from 'angular';

import { HelpersModule } from 'crowdcomms-js/lib/helpers';
import { LoadersModule } from 'crowdcomms-js/lib/ui/loaders';
import { ToastModule } from 'crowdcomms-js/lib/ui/toast';

import { WidgetComponentsModule } from './components';
import { WidgetI18nModule } from './i18n';

export const WidgetModule = angular.module('galabid-presenter.components.widget', [
    HelpersModule,
    LoadersModule,
    ToastModule,
    WidgetComponentsModule,
    WidgetI18nModule,
]).name;
